import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostCreateExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_EXCHANGE_RATES
            });
            window.location.replace('/settings/exchange-rates')
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreateExchangeRates as SetPostCreateExchangeRates
}